/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useState } from 'react'
import {
  Button,
  Modal,
  Table,
  Row,
  Toolbar,
  WhatsAppPreview,
  FormikErrorMessage,
  TextInput,
  SMSTemplatePreview
} from 'shared'
import { Panel, ButtonToolbar, Col } from 'rsuite'
import { Formik, Form, FormikProps } from 'formik'
import { useTableHandlers } from 'hooks/useTableHandlers'
import '../../../scss/common/list/List.scss'
import { notifyError, notifySuccess, notifyWarning } from 'utils'
import { useGetChannelOnboardingsQuery } from 'pages/channelOnBoarding/channelOnboardingApiSlice'
import { IFilter, Operator } from 'api/types'
import AdvertisementTemplateView from 'shared/molecules/advertisementPreview/AdvertisementPreview'
import { DateTimeCell, StatusCell } from 'shared/molecules/table/cells'
import TypeCell from 'shared/molecules/table/cells/TypeCell'
import TemplateStatusCell from 'shared/molecules/table/cells/TemplateStatusCell'
import LanguageCell from 'shared/molecules/table/cells/LanguageCell'
import { useGetAllComapnyQuery } from 'pages/Dashboard/dashboardApiSlice'
import CreateEditTemplate from '../createEditTemplate/CreateEditTemplate'
import useAuth from '../../../hooks/Auth'
import {
  useGetTemplatesQuery,
  useDeleteTemplateMutation,
  useFetchAdvertisementListQuery,
  useDeleteAdvertisementMutation,
  useUpdateTemplateApprovalMutation
} from '../templateApiSlice'
import {
  TEMPLATE_TYPE,
  TemplateForm,
  approvalValidationSchema,
  defaultTemplateFormValues,
  TEMPLATE_FORM_FIELDS
} from '../utils'
import {
  WhatsAppTemplate,
  TemplateListRequest,
  Advertisement,
  AdvertisementListRequest,
  UserTemplates,
  TemplateStatus,
  SmsTemplate,
  SmsListRequest
} from '../types'

const { Column, HeaderCell, Cell, ActionCell } = Table

const TemplateColumns = [
  { key: 'name', label: 'Template Name', width: 270 },
  { key: 'category', label: 'Category', width: 170 },
  { key: 'status', label: 'Status', width: 150 },
  { key: 'language', label: 'Language', width: 150 }
]
const { REASON } = TEMPLATE_FORM_FIELDS
const advetisementColumns = [
  { key: 'name', label: 'Name', width: 200 },
  { key: 'type', label: 'Type', width: 150 },
  { key: 'placementType', label: 'Placement Type', width: 200 },
  { key: 'languages', label: 'Language', width: 150 },
  { key: 'status', label: 'Status', width: 150 }
]
const smsColumns = [
  { key: 'name', label: 'Template Name', width: 270 },
  { key: 'senderId', label: 'Sender ID', width: 170 },
  { key: 'dltTemplateId', label: 'DLT ID', width: 170 },
  { key: 'status', label: 'Status', width: 150 }
]

const TemplateList: FC = () => {
  const [openTemplateModal, setOpenTemplateModal] = useState<boolean>(false)
  const { setopenEditProfile, isSubsId, isCompanyVerified } = useAuth()
  const [activeTab, setActiveTab] = useState<TEMPLATE_TYPE>(
    TEMPLATE_TYPE.WHATSAPP
  )
  const [openViewModal, setOpenViewModal] = useState<boolean>(false)
  const [selectedTemplate, setSelectedTemplate] = useState<any | null>(null)
  const [openAdvertisementPreview, setOpenAdvertisementPreview] =
    useState(false)
  const [openSMSPreview, setOpenSMSPreview] = useState(false)
  const [selectAdvertisement, setSelectAdvertisement] = useState<any | null>(
    null
  )
  const { role } = useAuth()
  const [editMode, setEditMode] = useState<boolean>(false)
  const [selectedDropdownValue, setSelectedDropdownValue] = useState<string>('')
  const [showApproveModal, setShowApproveModal] = useState<boolean>(false)
  const [showRejectReasonModal, setShowRejectReasonModal] =
    useState<boolean>(false)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
  const [itemToDelete, setItemToDelete] = useState<any | null>(null)
  const { data: companyData, isLoading: isCompanyLoading } =
    useGetAllComapnyQuery()
  const { onSortColumn, onFilterChange, requestBody, onPageChange } =
    activeTab === TEMPLATE_TYPE.INAPP
      ? useTableHandlers<Advertisement, AdvertisementListRequest>({
          filters: [],
          page: { size: 10, number: 1 }
        })
      : activeTab === TEMPLATE_TYPE.SMS
        ? useTableHandlers<SmsTemplate, SmsListRequest>({
            filters: [
              {
                fieldName: 'channel',
                operator: Operator.EQ,
                fieldValue: TEMPLATE_TYPE.SMS
              }
            ],
            page: { size: 10, number: 1 }
          })
        : useTableHandlers<WhatsAppTemplate, TemplateListRequest>({
            filters: [
              {
                fieldName: 'channel',
                operator: Operator.EQ,
                fieldValue: TEMPLATE_TYPE.WHATSAPP
              }
            ],
            page: { size: 20, number: 1 }
          })
  let actionOptions: string[] = []
  if (activeTab === TEMPLATE_TYPE.INAPP) {
    if (role?.includes('ROLE_ADMIN')) {
      actionOptions = ['View', 'Edit', 'Delete', 'Verification']
    } else {
      actionOptions = ['View', 'Edit', 'Delete']
    }
  } else {
    actionOptions = ['View', 'Delete']
  }
  const generateOptions = (
    data: { content: { name: string, subsId: number }[] } | undefined,
    isLoading: boolean
  ) =>
    isLoading
      ? []
      : (data?.content?.map((item: { name: string, subsId: number }) => ({
          label: item.name,
          value: item.subsId.toString()
        })) ?? [])
  const companyOptions = generateOptions(companyData, isCompanyLoading)

  const { data, isFetching, isLoading } = useGetTemplatesQuery(
    activeTab !== TEMPLATE_TYPE.INAPP
      ? (requestBody as TemplateListRequest)
      : ({} as TemplateListRequest),
    { skip: activeTab === TEMPLATE_TYPE.INAPP }
  )
  const [verifyUserTemplates] = useUpdateTemplateApprovalMutation()
  const { data: advertisementData, isLoading: isAdvertisementLoading } =
    useFetchAdvertisementListQuery(
      activeTab === TEMPLATE_TYPE.INAPP
        ? (requestBody as AdvertisementListRequest)
        : ({} as AdvertisementListRequest),
      { skip: activeTab !== TEMPLATE_TYPE.INAPP }
    )
  const total =
    activeTab === TEMPLATE_TYPE.INAPP
      ? (advertisementData?.totalElements ??
        advertisementData?.content?.length ??
        0)
      : (data?.totalElements ?? data?.data?.length ?? 0)
  const [deleteTemplate] = useDeleteTemplateMutation()
  const [deleteAdevertisement] = useDeleteAdvertisementMutation()
  const { data: channelData } = useGetChannelOnboardingsQuery({})

  const getDropdownOptions = (tab: TEMPLATE_TYPE) => {
    return (
      channelData?.content
        ?.filter((item) => item.channel === tab)
        ?.map((item) => ({
          label: item.businessInfo || item.channelId,
          value: tab === TEMPLATE_TYPE.SMS ? item.id : item.channelId
        })) || []
    )
  }

  const dropdownOptions = getDropdownOptions(activeTab)

  useEffect(() => {
    if (
      dropdownOptions.length > 0 &&
      !selectedDropdownValue &&
      activeTab === TEMPLATE_TYPE.WHATSAPP
    ) {
      const newValue = dropdownOptions[0]?.value ?? ''
      if (newValue !== selectedDropdownValue) {
        setSelectedDropdownValue(newValue)
        handleDropDownChange(newValue)
      }
    }
  }, [dropdownOptions, activeTab, selectedDropdownValue])

  const handleSortColumn = useCallback(
    (column: string, type?: any) => {
      onSortColumn(column, type)
    },
    [onSortColumn]
  )
  const handleTabChange = (tab: TEMPLATE_TYPE) => {
    setActiveTab(tab)

    let fieldValue
    switch (tab) {
      case TEMPLATE_TYPE.WHATSAPP:
        fieldValue = 'WHATSAPP'
        break
      case TEMPLATE_TYPE.SMS:
        fieldValue = 'SMS'
        break
      case TEMPLATE_TYPE.INAPP:
        fieldValue = 'INAPP'
        break
      default:
        fieldValue = 'WHATSAPP'
    }
    const currentFilters = requestBody.filters ?? []
    const updatedFilters: (
      | IFilter<WhatsAppTemplate>
      | IFilter<Advertisement>
    )[] = [
      {
        fieldName: 'channel' as keyof WhatsAppTemplate,
        operator: Operator.EQ,
        fieldValue
      }
    ]
    if (tab === TEMPLATE_TYPE.WHATSAPP) {
      const whatsappDropdownOptions = getDropdownOptions(TEMPLATE_TYPE.WHATSAPP)
      let channelIdValue = selectedDropdownValue

      if (!channelIdValue) {
        const existingChannelIdFilter = (
          currentFilters as Array<
            IFilter<WhatsAppTemplate> | IFilter<Advertisement>
          >
        ).find((f) => f.fieldName === 'channelId')
        channelIdValue =
          existingChannelIdFilter?.fieldValue ??
          whatsappDropdownOptions[0]?.value
      }

      if (channelIdValue) {
        updatedFilters.push({
          fieldName: 'channelId' as keyof WhatsAppTemplate,
          operator: Operator.EQ,
          fieldValue: channelIdValue
        })

        setSelectedDropdownValue(channelIdValue)
      }
    }

    onFilterChange(
      updatedFilters as IFilter<
        WhatsAppTemplate | SmsTemplate | Advertisement
      >[]
    )
    if (tab !== TEMPLATE_TYPE.WHATSAPP) {
      setSelectedDropdownValue('')
    }
  }
  const handleAccept = async () => {
    if (!selectAdvertisement?.id) return
    setIsSubmitting(true)
    try {
      const payload: UserTemplates = {
        id: Number(selectAdvertisement.id),
        status: TemplateStatus.ApprovedAdmin,
        reason: 'Verified by Admin'
      }

      await verifyUserTemplates({
        id: payload.id ?? 0,
        userTemplates: payload
      }).unwrap()

      notifySuccess('Template approved successfully')
      setShowApproveModal(false)
    } catch (error) {
      notifyError('Failed to approve template')
    } finally {
      setIsSubmitting(false)
    }
  }
  const handleReject = async (reason: string) => {
    if (!selectAdvertisement?.id) return
    setIsSubmitting(true)
    try {
      const payload: UserTemplates = {
        id: Number(selectAdvertisement.id),
        status: TemplateStatus.DisApprovedAdmin,
        reason
      }

      await verifyUserTemplates({
        id: payload.id ?? 0,
        userTemplates: payload
      }).unwrap()

      notifySuccess('Template rejected successfully')
      setShowApproveModal(false)
      setShowRejectReasonModal(false)
    } catch (error) {
      notifyError('Failed to reject template')
    } finally {
      setIsSubmitting(false)
    }
  }
  const handleDropdown = (value: string) => {
    const channelFilter: IFilter<Advertisement> = {
      fieldName: 'subId',
      operator: Operator.EQ,
      fieldValue: value ?? ''
    }

    const updatedFilters = [
      channelFilter,
      ...(
        (Array.isArray(requestBody.filters)
          ? requestBody.filters
          : []) as IFilter<Advertisement>[]
      ).filter((f) => f.fieldName !== 'subId')
    ]

    onFilterChange(
      updatedFilters as IFilter<
        WhatsAppTemplate | SmsTemplate | Advertisement
      >[]
    )
  }
  const smsDropdown = (value: string) => {
    const channelFilter: IFilter<SmsTemplate> = {
      fieldName: 'id',
      operator: Operator.EQ,
      fieldValue: value ?? ''
    }

    const updatedFilters = [
      channelFilter,
      ...(
        (Array.isArray(requestBody.filters)
          ? requestBody.filters
          : []) as IFilter<Advertisement>[]
      ).filter((f) => f.fieldName !== 'id')
    ]

    onFilterChange(
      updatedFilters as IFilter<
        WhatsAppTemplate | SmsTemplate | Advertisement
      >[]
    )
  }
  const handleDropDownChange = (value: string) => {
    setSelectedDropdownValue(value)
    const channelFilter: IFilter<WhatsAppTemplate> = {
      fieldName: 'channelId',
      operator: Operator.EQ,
      fieldValue: value ?? ''
    }

    const updatedFilters = [
      channelFilter,
      ...(
        (Array.isArray(requestBody.filters)
          ? requestBody.filters
          : []) as IFilter<WhatsAppTemplate>[]
      ).filter((f) => f.fieldName !== 'channelId')
    ]

    onFilterChange(
      updatedFilters as IFilter<
        WhatsAppTemplate | SmsTemplate | Advertisement
      >[]
    )
  }

  const options = [
    {
      label: 'WhatsApp',
      value: TEMPLATE_TYPE.WHATSAPP,
      onClick: () => handleTabChange(TEMPLATE_TYPE.WHATSAPP)
    },
    {
      label: 'SMS',
      value: TEMPLATE_TYPE.SMS,
      onClick: () => handleTabChange(TEMPLATE_TYPE.SMS)
    },
    {
      label: 'APP',
      value: TEMPLATE_TYPE.INAPP,
      onClick: () => handleTabChange(TEMPLATE_TYPE.INAPP)
    }
  ]

  let defaultType

  if (activeTab === TEMPLATE_TYPE.INAPP) {
    defaultType = TEMPLATE_TYPE.INAPP
  } else if (activeTab === TEMPLATE_TYPE.SMS) {
    defaultType = TEMPLATE_TYPE.SMS
  } else {
    defaultType = TEMPLATE_TYPE.WHATSAPP
  }
  const renderCell = (key: string) => {
    if (key === 'startDate' || key === 'endDate') {
      return <DateTimeCell dataKey={key} format="yyyy/MM/dd" />
    }
    if (key === 'language') {
      return <LanguageCell dataKey={key} />
    }
    if (key === 'advertisement_status') {
      return <StatusCell dataKey={key} />
    }
    if (key === 'status') {
      return <TemplateStatusCell dataKey={key} />
    }
    if (key === 'type' || key === 'placementType' || key === 'languages') {
      return <TypeCell dataKey={key} />
    }
    return <Cell dataKey={key} />
  }
  const getColumnsByTab = (tab: TEMPLATE_TYPE) => {
    if (tab === TEMPLATE_TYPE.INAPP) {
      return advetisementColumns
    }
    if (tab === TEMPLATE_TYPE.SMS) {
      return smsColumns
    }
    return TemplateColumns
  }
  const handleTemplateAction = () => {
    if (!isSubsId) {
      setopenEditProfile(true)
    } else if (!isCompanyVerified) {
      notifyWarning(
        'Sorry, your company documents are not verified yet. Once they verified, our team will contact you soon.'
      )
    } else {
      setOpenTemplateModal(true)
      setEditMode(false)
      setSelectAdvertisement(null)
    }
  }

  const onClose = () => {
    setOpenTemplateModal(false)
    setOpenViewModal(false)
    setEditMode(false)
    setSelectedTemplate(null)
    setSelectAdvertisement(null)
  }
  let dropdownProps = {}

  if (activeTab === TEMPLATE_TYPE.WHATSAPP) {
    dropdownProps = {
      dropdownData: dropdownOptions,
      searchable: true,
      onDropdownSelect: handleDropDownChange
    }
  }
  if (activeTab === TEMPLATE_TYPE.INAPP) {
    dropdownProps = {
      dropdownData: companyOptions,
      searchable: true,
      onDropdownSelect: handleDropdown
    }
  }
  if (activeTab === TEMPLATE_TYPE.SMS) {
    dropdownProps = {
      dropdownData: dropdownOptions,
      searchable: true,
      onDropdownSelect: smsDropdown
    }
  }
  const handleAction = async (action: string | undefined, rowData: any) => {
    if (!rowData) {
      return
    }
    switch (action) {
      case '1':
        if (activeTab === TEMPLATE_TYPE.INAPP) {
          setSelectAdvertisement(rowData)
          setOpenAdvertisementPreview(true)
        } else if (activeTab === TEMPLATE_TYPE.SMS) {
          setSelectedTemplate(rowData)
          setOpenSMSPreview(true)
        } else {
          setSelectedTemplate(rowData)
          setOpenViewModal(true)
        }
        break
      case '2':
        setSelectAdvertisement(rowData)
        setEditMode(true)
        setOpenTemplateModal(true)
        break
      case '3':
        if (!rowData) return
        setItemToDelete(rowData)
        setShowDeleteModal(true)
        break
      case '10':
        setSelectAdvertisement(rowData)
        setShowApproveModal(true)
        break

      default:
        break
    }
  }
  const handleConfirmDelete = async () => {
    if (!itemToDelete) return

    try {
      if (activeTab === TEMPLATE_TYPE.INAPP) {
        const id = itemToDelete?.id
        if (!id) {
          notifyError('Advertisement ID is missing.')
          return
        }
        await deleteAdevertisement({ id }).unwrap()
        notifySuccess('Template deleted successfully.')
      } else {
        const templateId = itemToDelete?.id
        const templateName = itemToDelete?.name
        const channelId = channelData?.content?.[0]?.channelId

        if (!templateId) {
          notifyError('Template ID is missing.')
          return
        }

        await deleteTemplate({
          templateId,
          templateName,
          channelId: channelId || ''
        }).unwrap()
        notifySuccess('Template deleted successfully.')
      }
    } catch (error) {
      notifyError('Error while deleting.')
    } finally {
      setShowDeleteModal(false)
      setItemToDelete(null)
    }
  }
  const renderFormButtons = (formikProps: FormikProps<TemplateForm>) => (
    <ButtonToolbar className="app-buttons-group">
      <Button
        className="formButton"
        disabled={formikProps?.isValidating ?? formikProps?.isSubmitting}
        onClick={() => {
          formikProps.resetForm()
        }}
      >
        Reset
      </Button>
      <Button
        className="formButton"
        appearance="primary"
        type="submit"
        disabled={formikProps?.isValidating ?? formikProps?.isSubmitting}
      >
        Submit
      </Button>
    </ButtonToolbar>
  )
  return (
    <div className="list">
      <Toolbar
        onButtonClick={handleTemplateAction}
        buttonName="Create Template"
        total={total}
        options={options}
        dropdownPlaceholder={
          role?.includes('ROLE_ADMIN')
            ? activeTab === TEMPLATE_TYPE.INAPP
              ? 'Select Company'
              : 'Select Channel'
            : 'Select Channel'
        }
        {...(role?.includes('ROLE_ADMIN') && {
          dropdownData: companyOptions,
          onDropdownSelect: handleDropdown
        })}
        {...dropdownProps}
      />

      <div className="list__main-container">
        <Table
          data={
            activeTab === TEMPLATE_TYPE.INAPP
              ? (advertisementData?.content as unknown as WhatsAppTemplate[])
              : (data?.data ?? data?.content ?? [])
          }
          loading={isLoading || isFetching || isAdvertisementLoading}
          paginated
          pageSizeOptions={[10, 20, 30]}
          total={total}
          defaultPageSize={data?.size ?? 10}
          onPageChange={onPageChange}
          onSortColumn={handleSortColumn}
        >
          {getColumnsByTab(activeTab).map((column, index) => {
            const { key, label } = column
            return (
              <Column
                flexGrow={1}
                key={key}
                align={index === 0 ? 'left' : 'center'}
                sortable
              >
                <HeaderCell>{label}</HeaderCell>
                {renderCell(key)}
              </Column>
            )
          })}
          <Column flexGrow={1}>
            <HeaderCell>Action</HeaderCell>
            <ActionCell
              dataKey="action"
              onAction={handleAction}
              actionOptions={actionOptions}
              tooltip
            />
          </Column>
        </Table>
      </div>

      {openTemplateModal && (
        <CreateEditTemplate
          open={openTemplateModal}
          onClose={onClose}
          isEditMode={editMode}
          advertisement={selectAdvertisement}
          defaultType={defaultType}
        />
      )}
      {showDeleteModal && (
        <Modal
          open={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          title="Confirm Delete"
          size="calc(40% - 120px)"
          className="delete-modal"
          body={
            <div className="modal-content">
              <p className="modal-text">
                Are you sure you want to delete this Template?
              </p>
              <div className="modal-buttons">
                <div>
                  <Button
                    onClick={() => setShowDeleteModal(false)}
                    appearance="primary"
                    color="red"
                    className="no-btn"
                  >
                    No
                  </Button>
                </div>
                <div>
                  <Button
                    onClick={handleConfirmDelete}
                    appearance="primary"
                    className="yes-btn"
                  >
                    Yes
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      )}
      <WhatsAppPreview
        open={openViewModal}
        selectedTemplate={selectedTemplate}
        onClose={onClose}
      />
      <AdvertisementTemplateView
        open={openAdvertisementPreview}
        onClose={() => setOpenAdvertisementPreview(false)}
        selectedAdvertisementTemplate={selectAdvertisement}
      />
      <SMSTemplatePreview
        open={openSMSPreview}
        onClose={() => setOpenSMSPreview(false)}
        selectedTemplate={selectedTemplate}
      />
      {showApproveModal && (
        <Modal
          open={showApproveModal}
          onClose={() => setShowApproveModal(false)}
          title="Verify Template"
          size="calc(40% - 120px)"
          className="approve-modal"
          body={
            <div className="modal-content">
              <p className="modal-text modal-text-verification">
                Please Accept or Reject this template?
              </p>
              <div className="modal-buttons">
                <div>
                  <Button
                    onClick={() => setShowRejectReasonModal(true)}
                    appearance="primary"
                    color="red"
                    className="reject-btn"
                    disabled={
                      isSubmitting ||
                      selectAdvertisement?.status === 'DisApprovedAdmin'
                    }
                  >
                    Reject
                  </Button>
                </div>
                <div>
                  <Button
                    appearance="primary"
                    className="accept-btn"
                    onClick={handleAccept}
                    disabled={
                      isSubmitting ||
                      selectAdvertisement?.status === 'ApprovedAdmin'
                    }
                  >
                    Accept
                  </Button>
                </div>
              </div>
            </div>
          }
        />
      )}
      {showRejectReasonModal && (
        <Modal
          open={showRejectReasonModal}
          onClose={() => setShowRejectReasonModal(false)}
          title="Rejection Reason"
          size="calc(50% - 120px)"
          secondary
          body={
            <div className="campaign-form-section">
              <Formik
                initialValues={{
                  ...defaultTemplateFormValues,
                  reason: ''
                }}
                validationSchema={approvalValidationSchema}
                onSubmit={(values: TemplateForm) => {
                  handleReject(values.reason)
                }}
              >
                {(formikProps: FormikProps<TemplateForm>) => (
                  <Form className="create-edit">
                    <Panel>
                      <div className="app-channel-container">
                        <Row>
                          <Col xs={18}>
                            <TextInput
                              id={TEMPLATE_FORM_FIELDS.REASON}
                              formik={formikProps}
                              name={REASON}
                              placeholder="Enter reason"
                            />
                            <FormikErrorMessage name={REASON} />
                          </Col>
                        </Row>
                      </div>
                    </Panel>
                    <Panel>{renderFormButtons(formikProps)}</Panel>
                  </Form>
                )}
              </Formik>
            </div>
          }
        />
      )}
    </div>
  )
}

export default TemplateList
